import { default as WscIconCursorsClosedHand } from "./CursorsClosedHand";
import { default as WscIconCursorsDragLeft } from "./CursorsDragLeft";
import { default as WscIconCursorsDragRight } from "./CursorsDragRight";
import { default as WscIconCursorsMove } from "./CursorsMove";
import { default as WscIconCursorsNotAllowed } from "./CursorsNotAllowed";
import { default as WscIconCursorsPress } from "./CursorsPress";

const icons = {
  WscIconCursorsClosedHand,
  WscIconCursorsDragLeft,
  WscIconCursorsDragRight,
  WscIconCursorsMove,
  WscIconCursorsNotAllowed,
  WscIconCursorsPress,
};

export default icons;
